import { useMutation } from '@apollo/client';
import { queries } from './queries';

const useIncreaseView = () =>
  useMutation(queries.view, {
    errorPolicy: 'all',
  });

export default useIncreaseView;
